export default {"src":"/kelp/_next/static/media/footer_logo.b26280fe.svg","height":43,"width":237,"blurWidth":0,"blurHeight":0};